export default __webpack_public_path__ + "static/media/red.94a0208a.gif";